import { render, staticRenderFns } from "./SingleZoneStandart.vue?vue&type=template&id=f6621f4a&scoped=true&"
import script from "./SingleZoneStandart.vue?vue&type=script&lang=js&"
export * from "./SingleZoneStandart.vue?vue&type=script&lang=js&"
import style0 from "./SingleZoneStandart.vue?vue&type=style&index=0&id=f6621f4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6621f4a",
  null
  
)

export default component.exports